/**
 * GDPR-style cookie consent banner.
 * Shown on first visit until user makes a choice.
 * Rendered via portal to document.body to ensure visibility.
 * Accessible: keyboard nav, screen-reader friendly.
 */
import React from 'react'
import { createPortal } from 'react-dom'
import { Box, Button, Typography } from '@mui/material'
import { useConsent } from '../../contexts/ConsentContext'
import './CookieBanner.css'

const CookieBanner = () => {
  const {
    showBanner,
    acceptAll,
    rejectNonEssential,
    openPreferences,
  } = useConsent()

  if (!showBanner) return null

  const banner = (
    <div
      className="cookie-banner"
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-desc"
    >
      <Box className="cookie-banner-content">
        <Typography id="cookie-banner-title" variant="h6" component="h2" className="cookie-banner-title">
          Utilizzo dei cookie
        </Typography>
        <Typography id="cookie-banner-desc" variant="body2" className="cookie-banner-desc">
          Utilizziamo cookie essenziali per il funzionamento dell&apos;app e cookie opzionali per
          analisi e miglioramento del servizio. Puoi accettare tutti, rifiutare i non essenziali o
          gestire le preferenze.
        </Typography>
        <div className="cookie-banner-actions">
          <Button
            variant="outlined"
            size="small"
            onClick={rejectNonEssential}
            className="cookie-banner-btn reject"
            aria-label="Rifiuta cookie non essenziali"
          >
            Rifiuta non essenziali
          </Button>
          <Button
            variant="text"
            size="small"
            onClick={() => openPreferences()}
            className="cookie-banner-btn preferences"
            aria-label="Gestisci preferenze cookie"
          >
            Preferenze
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={acceptAll}
            className="cookie-banner-btn accept"
            aria-label="Accetta tutti i cookie"
          >
            Accetta tutti
          </Button>
        </div>
      </Box>
    </div>
  )

  return typeof document !== 'undefined' && document.body
    ? createPortal(banner, document.body)
    : banner
}

export default CookieBanner
